export default "__VITE_ASSET__BvbGlGXP__"